export default __webpack_public_path__ + "static/media/ic_service_center.8d6ee8a2.svg";